




import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PartCatalogCardYesno extends Vue  {
  @Prop({ type: Boolean, required: true })
  value: boolean;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/catalog/card/components/sidebar/components/YesNo.vue